import React from "react"
import Cta from "../components/cta"
import instagramData from "../data/instagram.json"
import { shuffle } from "../helpers/arrays"
import Image from "../components/image"

export default function SiteFooterInstagram({ path }) {
  const totalPosts = 3

  var pagePosts = shuffle(
    instagramData.filter(obj => {
      return obj.paths.includes(path)
    })
  )

  if (pagePosts.length < totalPosts) {
    var otherPosts = shuffle(
      instagramData.filter(obj => {
        return !obj.paths.includes(path)
      })
    )
  }

  const posts = pagePosts.concat(otherPosts).slice(0, totalPosts)

  return (
    <li className="site-footer__instagram">
      <header>
        <h3 className="title--m">Instagram Highlights</h3>
        <div className="title--xs">
          <a href="https://www.instagram.com/the_imf/">@the_imf</a>
        </div>
      </header>
      <ul>
        {posts.map((post, index) => (
          <li key={`${post.paths}-${post.id}-${index}`}>
            <a href={post.url} target="_blank" rel="noreferrer">
              <Image path={post.image_path} alt={post.alt} />
            </a>
          </li>
        ))}
      </ul>
      <Cta
        type="secondary"
        href="https://www.instagram.com/the_imf/"
        text="Follow Us"
      />
    </li>
  )
}
